<template>
  <div class="shoppe">
    <h1 class="mb10">ES index 和数据</h1>
    <el-link type="primary" @click="getIndexList">刷新列表数据</el-link>
    <el-table :data="module1.tableData" v-loading="module1.loading">
      <el-table-column prop="index" label="index名称"></el-table-column>
      <el-table-column prop="total" label="现有数据量"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link type="primary" style="margin-right: 10px;" v-if="!scope.row.isUse" @click="setItemUse(scope.row)">使用当前index</el-link>
          <el-link type="primary" v-if="!scope.row.isUse" @click="delIndex(scope.row)">删除当前index</el-link>
        </template>
      </el-table-column>
    </el-table>

    <h1 class="mt20 mb10">操作全量</h1>
    <h4>默认推送近600天的订单   <el-link type="primary" @click="loadPushStatus">刷新全量推送结果</el-link></h4>
    <el-button type="primary" @click="pushAllIndex">推送全量</el-button>
    <p>全量推送结果：{{ pushResult }}</p>

    <h1 class="mt20 mb10">操作增量</h1>
    <el-form :inline="true" :model="formInline">
      <el-form-item label="订单号">
        <el-input v-model="formInline.purchaseOrderNo"></el-input>
      </el-form-item>
      <el-form-item label="vendorId">
        <el-input v-model="formInline.vendorId"></el-input>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker
          style="width: 250px"
          v-model="daterange"
          type="daterange"
          value-format="timestamp"
          :editable="false"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">推送增量</el-button>
      </el-form-item>
    </el-form>
    <p>注：多个订单号或者vendorId请用英文逗号分隔</p>

  </div>
</template>

<script>
import {
  getIndexList,
  indexPushAll,
  changeUseIndex,
  delIndex,
  loadPushAllStatus,
  indexPushIncremental
} from "../../api/trace";
import utils from '@/utils/util';

export default {
 data() {
    return {
      module1: {
        loading: false,
        tableData: [],
      },
      formInline: {
        purchaseOrderNo: null,
        vendorId: null,
      },
      daterange: [],
      pushResult: null
    };
  },
  mounted() {
    this.getIndexList();
    this.loadPushStatus();
  },
  methods: {
    getIndexList() {
      this.module1.loading = true;
      getIndexList().then(res => {
        if (res.data) {
          this.module1.tableData = res.data.data || [];
        }
        this.module1.loading = false;
      });
    },
    loadPushStatus() {
        loadPushAllStatus().then(res => {
          this.pushResult = res.data.message;
        })
    },
    setItemUse(row) {
      this.$confirm("确认要切换到当前index吗?",'提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        changeUseIndex({
          indexName: row.index
        })
        .then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.message);
            this.getIndexList();
          } else {
            this.$message.error(res.data.message);
          }
        })
      })
    },
    delIndex(row) {
      this.$confirm("此操作不可恢复，确认要删除当前index吗?",'提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        delIndex({
          indexName: row.index
        })
        .then((res)=>{
          if (res.data.success) {
            this.$message.success(res.data.message);
            this.getIndexList();
          } else {
            this.$message.error(res.data.message);
          }
        })
      })
    },
    pushAllIndex() {
      // TODO 判断状态，禁用按钮？
      this.$confirm('是否推送全量？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        indexPushAll().then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.message);
            this.getIndexList();
            this.loadPushStatus();
          } else {
            this.$message.error(res.data.message || this.$t('error.systemerror'));
          }
        })
      }).catch(() => {});
    },
    onSubmit() {
      this.formInline.purchaseOrderNo = this.formInline.purchaseOrderNo && this.formInline.purchaseOrderNo.trim();
      this.formInline.vendorId = this.formInline.vendorId && this.formInline.vendorId.trim();
      if (!this.formInline.purchaseOrderNo && !this.formInline.vendorId && this.daterange.length === 0) {
        this.$message.info('订单号或店铺ID或者日期至少输入一个');
        return;
      }
      this.$confirm('是否推送增量数据？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        indexPushIncremental({
          purchaseOrderNos: this.formInline.purchaseOrderNo ? this.formInline.purchaseOrderNo.split(',') : [],
          vendorIds: this.formInline.vendorId ? this.formInline.vendorId.split(',') : [],
          startTime: this.daterange[0] ? this.daterange[0] : null,
          endTime: this.daterange[1] ? this.daterange[1] : null,
        }).then((res) => {
          if (res.data.success) {
            this.$message.success('操作成功');
          } else {
            this.$message.error(res.data.message || this.$t('error.systemerror'));
          }
        })
      }).catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.mt20 {
  margin-top: 20px;
}
.mb10 {
  margin-bottom: 10px;
}
</style>
